











import { Component, Vue, Prop, Provide, Emit, Watch } from 'vue-property-decorator'
import { msgTip } from '@/utils/urlUtils'
import { AButton, PayModal, PayAgreement } from '../../components'
import mainTemplate from '@/components/MainTemplate.vue'
import QuestionDetail from '@/components/paper/Question.vue'
import Main from './components/Main.vue'
import QuestionBus from './components/QuestionBus.vue'
import UploadPhotos from './components/UploadPhotos.vue'
import { sa } from '@/utils/sa'

@Component({
  components: {
    mainTemplate,
    // eslint-disable-next-line vue/no-unused-components
    QuestionDetail,
    Main,
    PayModal,
    PayAgreement,
    QuestionBus,
    UploadPhotos
    // AButton
  }
})
export default class Question extends Vue {
  /**
   * name
   */
  public name() {}
  // token
  public get token() {
    return this.$route.query.token || null
  }
  // style
  public get style() {
    return this.$route.query.style || null
  }
  // mounted
  public mounted() {
    if (this.token) {
      if (this.style == 'wx') {
        setTimeout(() => {
          sa.track('ContentRepository_Share', {
            action: '点击分享链接',
            shareChannel: '微信分享'
          })
        }, 50)
      } else if (this.style == 'qq') {
        setTimeout(() => {
          sa.track('ContentRepository_Share', {
            action: '点击分享链接',
            shareChannel: 'QQ分享'
          })
        }, 50)
      } else {
        setTimeout(() => {
          sa.track('ContentRepository_Share', {
            action: '点击分享链接',
            shareChannel: '复制分享'
          })
        }, 50)
      }
    }
  }
}
